export const PERIOD_LOADING = 'PERIOD_LOADING';
export const PERIOD_FULFILLED = 'PERIOD_FULFILLED';
export const PERIODS_FULFILLED = 'PERIODS_FULFILLED';
